import { NavLink, useLocation } from "react-router";
import ProfilItem from "../../components/Profils/ProfilItem";
import { useMyProfilQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { LocationState } from "../../types/QueryParameters";

function Profil() {
  const profilQuery = useMyProfilQuery();
  const location = useLocation();
  const state = location.state as LocationState | undefined;
  const {translate}=useTrads();
 
  return (
    <div>
      <h2>{translate('title_profil')}</h2>
        {state?.modified && <p className="p-3 mb-2 bg-success text-white">{translate('msg_profil_update')}</p>}
        {profilQuery.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        profilQuery.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        profilQuery.data && 
        <>
          <ProfilItem profil={profilQuery.data} /> 
          <NavLink to="/profil/edit">{translate('btn_edit')}</NavLink>
        </>
      }

    </div>
  );
}
export default Profil;
